import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getProject } from "../../features/projectsSlice";
import MainContainer from "../../components/container/MainContainer";
import PageTitle from "../../components/titles/PageTitle";
import TextContainer from "../../components/text/TextContainer";
import LinkTextContainer from "../../components/text/LinkTextContainer";
import DisplayComments from "../../components/text/DisplayComments";
import TextArrayContainer from "../../components/text/TextArrayContainer";
import BudgetTableContainer from "../../components/text/BudgetTableContainer";
import loadStatus from "../../util/loadStatus";
import Loading from "../../components/loading/Loading";
import NetworkError from "../error/NetworkError";

const SingleCanceledProject = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const project = useSelector((state) => state.projects.selected); // List of ongoing projects
  const modalContent = useSelector((state) => state.modal.content);
  const loading = useSelector((state) => state.projects.load.getProject);

  useEffect(() => {
    if (id) {
      dispatch(getProject(id));
    }
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <div className="w-full max-w-5xl mx-auto text-text-1/70">
        <div className="sm:flex justify-between items-center py-4">
          <PageTitle title="Canceled Projects" />
        </div>

        {project.id && (
          <>
            <div className="mx-auto max-w-5xl w-full bg-content shadow-md px-5 py-6 flex flex-col gap-0.5">
              <h5 className="summary-p text-lg mb-4">
                <span className=" ">{project.name}</span>
              </h5>
              <TextContainer
                label="Name of Applicant"
                content={`${project.creator.first_name} ${
                  project.creator.other_names + " " || ""
                }${project.creator.last_name}`}
              />
              <TextContainer label="Community" content={project.community} />
              <TextContainer
                label="Address 1"
                content={project.community_address1}
              />
              <TextContainer
                label="Address 2"
                content={project.community_address2}
              />
              <TextContainer label="Province" content={project.province} />
              <TextContainer
                label="Address Project Location"
                content={project.project_location}
              />
              <TextContainer label="Email" content={project.creator.email} />
              <TextContainer label="Contact" content={project.creator.phone} />
              {/* Comments */}
              <DisplayComments comments={project.comments} />
              {/* Body */}
              <TextContainer
                label="Analysis"
                content={project.analysis}
                isHTML
              />
              <TextContainer
                label="Problem Statement"
                content={project.problem_statement}
                isHTML
              />
              <TextContainer
                label="Proposed (Idea) Solution"
                content={project.proposed_solution}
                isHTML
              />
              {/* The Documents */}
              <LinkTextContainer
                document={project.supporting_docs}
                role="Applicant"
                title="Supporting Documents"
              />
              <LinkTextContainer
                document={project.community_council_minute}
                role="Community"
                title="Community Council Minutes"
              />
              <LinkTextContainer
                document={project.provincial_council_minute}
                role="Province"
                title="Provincial Council Minutes"
              />
              {/* Proposal Content */}
              <>
                {project.description && (
                  <>
                    <TextContainer
                      label="Planned Start Date"
                      content={new Date(
                        project.planned_start_date
                      ).toDateString()}
                    />
                    <TextContainer
                      label="Planned End Date"
                      content={new Date(
                        project.planned_end_date
                      ).toDateString()}
                    />
                    <TextContainer
                      label="Currency"
                      content={project.currency}
                    />
                    <TextContainer
                      label="Background"
                      isHTML
                      content={project.description}
                    />
                    <TextContainer isHTML label="Goal" content={project.aim} />
                    <TextContainer
                      isHTML
                      label="Purpose"
                      content={project.purpose}
                    />
                    <TextArrayContainer
                      label="Activities"
                      content={project.activities}
                    />
                    <TextArrayContainer
                      label="Results"
                      content={project.expected_results}
                    />
                    <TextArrayContainer
                      label="Objectives"
                      content={project.objectives}
                    />
                    <TextContainer
                      isHTML
                      label="Selected Indicators"
                      content={project.selected_indicators}
                    />
                    <TextContainer
                      isHTML
                      label="Sustainability Plan"
                      content={project.sustainability_plan}
                    />
                    <TextContainer
                      isHTML
                      label="Justification"
                      content={project.justification}
                    />
                    <TextContainer
                      isHTML
                      label="Monitoring and Supervision"
                      content={project.monitoring_supervision}
                    />
                    <TextContainer
                      isHTML
                      label="How this project helps address the issues of the GC26 & DC27"
                      content={project.issues}
                    />
                    {/*  */}
                    <TextContainer
                      label="Target Group"
                      content={project.stakeholder_target_group}
                    />
                    <TextContainer
                      label="Male Beneficiaries"
                      content={project.male_beneficiaries}
                    />
                    <TextContainer
                      label="Female Beneficiaries"
                      content={project.female_beneficiaries}
                    />

                    {/* Budget */}
                    <div className="w-full overflow-x-auto">
                      <BudgetTableContainer
                        label="Budget"
                        content={project.budget || []}
                      />
                    </div>

                    {/* Documents */}

                    <LinkTextContainer
                      document={project.proposal_community_council_minute}
                      role="Community"
                      title="Community Council Minutes: "
                    />

                    <LinkTextContainer
                      document={project.proposal_provincial_council_minute}
                      role="Provincial"
                      title="Provincial Council Minutes: "
                    />
                  </>
                )}
              </>
            </div>
            {/* Buttons */}
            <div className="max-w-5xl w-full mx-auto">
              <div className="flex justify-between items-center pt-4 pb-10">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/projects/canceled-projects");
                  }}
                  className="cancel-rss-btn"
                >
                  Back
                </button>
                <button
                  disabled
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/projects/canceled-projects");
                  }}
                  className="add-rss-btn"
                >
                  Revive
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </MainContainer>
  );
};

export default SingleCanceledProject;
